import React from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'

const WrapperTextArea = styled.div`
  display: ${props => props.display};
  margin: ${props => props.margin};
  width: ${props => props.width};
  height: ${props => props.height};
  position: relative;
  box-sizing: border-box;
  font-family: 'Open Sans', sans-serif;
  label {
    position: absolute;
    top: ${pxToRem('8px')};
    font-size: ${pxToRem('14px')};
    color: #93a2ac;
    transition: 0.2s;
    -ms-transform: translateY('10px') translateY(${pxToRem('8px')});
    transform: translate(${pxToRem('10px')}, ${pxToRem('8px')});
    ${({ value }) =>
    !!value && `
      color: ${color.primary};
      -ms-transform: translateY(-100%) translateY(${pxToRem('-8px')});
      transform: translateY(calc(-100% + ${pxToRem('-8px')}));
      font-size: ${pxToRem('12px')};
    `};
  }
  .bar {
    width: 0;
    margin: auto;
    transition: 0.2s;
    background: #eee;
    height: 2px;
    display: block;
    position: absolute;
  }
  textarea {
    resize: none;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
    outline: none;
    font-size: ${pxToRem('14px')};
    position: relative;
    padding: 5px;
    min-width: ${props => `calc(${props.label.length} * ${pxToRem('8px')})`};
    &:focus {
      & ~ label {
        color: ${color.primary};
        -ms-transform: translateY(-100%) translateY(${pxToRem('-8px')});
        transform: translateY(calc(-100% + ${pxToRem('-8px')}));
        font-size: ${pxToRem('12px')};
      }
      & ~ .bar {
        width: 100%;
        opacity: 1;
        background: ${color.primary};
      }
    }
  }
`

class TextArea extends React.Component {
  render() {
    const {
      display = 'block',
      margin = '0 0 0 0',
      width = '100%',
      height = '200px',
      cols,
      rows,
      label,
      value,
      onChange
    } = this.props

    return (
      <WrapperTextArea 
        display={display} 
        cols={cols} 
        rows={rows} 
        label={label} 
        width={width} 
        height={height} 
        margin={margin}
        value={value}
        onChange={onChange}>
        <textarea cols={cols} rows={rows} value={value} onChange={onChange}></textarea>
        <span className="bar" />
        <label>{label}</label>
      </WrapperTextArea>
    )
  }
}

export default TextArea


// WEBPACK FOOTER //
// ./src/components/Form/TextArea.js